import { SupportedTokenName } from "@mezo/sdk"
import { Block, ParagraphLarge } from "@mezo-org/mezo-clay"

import DepositToken from "#/ui-old/Deposit/DepositToken/DepositToken"

type ReadOnlyAssetInputProps = {
  token: SupportedTokenName
  amount: string
}

export default function ReadOnlyAssetInput({
  token,
  amount,
}: ReadOnlyAssetInputProps) {
  return (
    <Block
      display="flex"
      alignItems="center"
      width="100%"
      justifyContent="space-between"
    >
      <ParagraphLarge
        overrides={{ Block: { style: () => ({ fontSize: "32px" }) } }}
      >
        {amount}
      </ParagraphLarge>
      <DepositToken token={token} pos="static" pt={0} h="auto" />
    </Block>
  )
}
